import { z } from 'zod';

export const legalClientDocumentTypeSchema = z.object({
  idLegalClientDocumentType: z.number(),
  LegalClientDocumentType: z.string(),
  BusinessForm_idBusinessForm: z.number().nullable().optional(),
  /**
   * Wird diese Dokumentart im GwG-Ordner eines Vorgangs geprüft und überwacht?
   * Pflegbar in der Datenbank, damit eine Kanzlei weitere Arten aufnehmen kann.
   * MariaDB liefert 0/1, deshalb beides tolerieren.
   */
  isGwGRelevant: z
    .union([z.boolean(), z.number().transform(value => value === 1)])
    .nullable()
    .optional(),
});

export type ILegalClientDocumentType = z.infer<
  typeof legalClientDocumentTypeSchema
>;

/**
 * Ist die Dokumentart GwG-relevant?
 *
 * Bewusst als Funktion und nicht als Vergleich `=== true`: MariaDB liefert
 * `TINYINT(1)` als **Zahl** 0/1, und die Listen-Endpoints werden nicht durch das
 * zod-Schema geparst (`useGetLegalClientDocumentTypes` castet nur den Typ). Ein
 * `=== true` ist deshalb immer falsch, obwohl der Wert gesetzt ist.
 */
export const isGwGRelevantDocumentType = (
  documentType: ILegalClientDocumentType
): boolean => Boolean(documentType.isGwGRelevant);
